import { defineStore } from 'pinia';
// import api from '🔗/api';
// import stores from '🔗/stores';
import { TGS_DEFAULT_LIKE } from '🔗/constants';

const useFavoriteStore = defineStore('favorite-store', {
    state: () => ({
    }),
    actions: {
        async getStickers({ entity, id, field, defaultItems=[] }) {
            let items = defaultItems;

            const result = await api.entity().owner(entity, id, field);

            if (result) {
                try {
                    const values = JSON.parse(result)?.values;

                    if (values?.length) {
                        items = values;
                    }
                } catch (e) {
                }
            }

            return items.map(item => `${import.meta.env.VITE_APP_TGS_URL}/${item.collection}/${item.code}.tgs`);
        },

        // Roles
        async remove({ entity, id, params }) {
            await api.favorite()[entity]?.remove(id);
        },
        async like({ entity, id, params }) {
            await api.favorite()[entity]?.like(id);

            const stickers = await this.getStickers({
                entity,
                id,
                field: 'REACTION_LIKE',
                defaultItems: TGS_DEFAULT_LIKE
            });

            if (stickers?.length) {
                stores.tgs().explode(params?.pageX, params?.pageY, {
                    stickers,
                    type: params?.type || 'burst',
                    count: 8,
                    speed: 5
                });
            }


            // А что бы нет? Попробую
            // const items = ['queen-dust', 'knock-knock', 'seven-nation', 'eye-tiger'];
            // const randomItem = items[Math.floor(Math.random() * items.length)];
            stores.others().vibroSong('queen-dust');
        },
        async dislike({ entity, id, params }) {
            await api.favorite()[entity]?.dislike(id);

            const stickers = await this.getStickers({
                entity,
                id,
                field: 'REACTION_DISLIKE',
                defaultItems: []
            });

            if (stickers?.length) {
                stores.tgs().explode(params?.pageX, params?.pageY, {
                    stickers,
                    type: params?.type || 'rain',
                    // count: 8,
                    // speed: 5
                });
            }
        }
    }
});

export default useFavoriteStore;
